export default function PlainCard({ children, type }) {
    return <div className={`plain-card ${type}`}>
        { children }
    </div>
}